import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";

// Constants
const PAGE_ID = 1;
const BG_ID = 1;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const LAST_PAGE = false;

const LEFT_TITLE = "Gen-AI powered\nNetwork Plan and Build";

// Image slider component
const ImageSlider = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  useEffect(() => {
    setIsVisible(false); // Reset visibility when page changes
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    return () => clearTimeout(timer);
  }, [currentPage]); // This effect will run on currentPage changes

  const images = [1, 2, 3];
  const GAP = "calc(var(--width-73) * -1)";

  return (
    <div
      ref={containerRef}
      style={{
        position: "absolute",
        top: "50%",
        right: 0,
        transform: "translateY(-50%)",
        width: "60%",
        height: "auto",
        pointerEvents: "none",
        zIndex: 10,
        overflow: "hidden",
      }}
    >
      {images.map((index, i) => (
        <div
          key={index}
          style={{
            marginTop: i === 0 ? "var(--width-50)" : 0,
            marginBottom: i < images.length - 1 ? GAP : 0,
            width: "100%",
            opacity: isVisible ? 1 : 0,
            transform: `translateX(${isVisible ? 0 : "100%"})`,
            transition: `opacity 0.7s ease-out, transform 0.7s ease-out`,
            transitionDelay: `${i * 0.3}s`,
          }}
        >
          <img
            src={`${Config.BASE_URL}/images/screen_${PAGE_ID}/right_${index}.png`}
            alt={`Presentation Data ${index}`}
            style={{
              width: "75%",
              height: "auto",
              display: "block",
              animation: `glow 3s ease-in-out infinite`,
            }}
          />
        </div>
      ))}
    </div>
  );
};

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const leftAfterDescription = (
    <div style={{ padding: "var(--width-10) 0" }}>
      <img
        src={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_separator.png`}
        alt="separator"
        style={{
          width: "var(--width-565)",
          height: "auto",
        }}
      />
      <div
        style={{
          color: "#fff",
          fontFamily: "Myriad Pro",
          fontSize: "var(--width-24)",
          fontStyle: "normal",
          fontWeight: "380",
          lineHeight: "150%",
          whiteSpace: "pre-line",
        }}
      >
        <p
          style={{
            marginTop: "var(--width-30)",
            marginBottom: "var(--width-10)",
          }}
        >
          Copilot solution to simplify generation of TOSCA
          <br />
          Network Service Templates. Accelerates design and
          <br />
          deployment of networks for telco operators
        </p>
      </div>
    </div>
  );

  const nextButton = !LAST_PAGE
    ? {
        label: "Next",
        type: "next" as const,
        endIcon: { icon: "arrow-left" },
        onClick: () => setCurrentPage(NEXT_PAGE_ID),
      }
    : undefined;

  return {
    bgVideo: {
      poster: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
      video: `${Config.BASE_URL}/videos/bg_${PAGE_ID}.mp4`,
    },
    gradient:
      "linear-gradient(270deg, rgba(21, 50, 121, 0.00) 11.77%, #153279 87.81%), linear-gradient(0deg, rgba(0, 0, 0, 0.60) 0%, rgba(0, 0, 0, 0.60) 100%)",
    title: LEFT_TITLE,
    leftAfterDescription: leftAfterDescription,
    // Force remount of ImageSlider on currentPage change by using key={currentPage}
    rightSideComponent: <ImageSlider key={currentPage} />,
    next: nextButton,
  };
};

export default DATA;
